/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrimaryDiscographyRequestSortFieldsInner
 */
export interface PrimaryDiscographyRequestSortFieldsInner {
    /**
     * 
     * @type {string}
     * @memberof PrimaryDiscographyRequestSortFieldsInner
     */
    field: PrimaryDiscographyRequestSortFieldsInnerFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof PrimaryDiscographyRequestSortFieldsInner
     */
    order: PrimaryDiscographyRequestSortFieldsInnerOrderEnum;
}


/**
 * @export
 */
export const PrimaryDiscographyRequestSortFieldsInnerFieldEnum = {
    EvidenceAvailable: 'evidence_available',
    ParentRecordingBandArtistNameRaw: 'parentRecording.bandArtistName.raw',
    ParentRecordingRecordingTitleRaw: 'parentRecording.recordingTitle.raw',
    ParentRecordingDuration: 'parentRecording.duration',
    ParentRecordingIsrcs: 'parentRecording.isrcs',
    ParentRecordingLive: 'parentRecording.live',
    ParentRecordingYearRecorded: 'parentRecording.yearRecorded',
    ParentRecordingRecordingVersion: 'parentRecording.recordingVersion',
    EarliestParentReleaseReleaseTitleRaw: 'earliestParentRelease.releaseTitle.raw',
    EarliestParentReleaseDateReleased: 'earliestParentRelease.dateReleased',
    EarliestParentReleaseMediaType: 'earliestParentRelease.mediaType',
    EarliestParentReleaseFormat: 'earliestParentRelease.format',
    EarliestParentReleaseReleaseLabels: 'earliestParentRelease.releaseLabels',
    EarliestParentReleaseCatNumbers: 'earliestParentRelease.catNumbers',
    PersonaStageName: 'persona.stageName',
    PerformanceFeaturedStatus: 'performance.featuredStatus',
    WestburyContributionsWestburyContribution: 'westburyContributions.westburyContribution',
    WestburyContributionsContribution: 'westburyContributions.contribution'
} as const;
export type PrimaryDiscographyRequestSortFieldsInnerFieldEnum = typeof PrimaryDiscographyRequestSortFieldsInnerFieldEnum[keyof typeof PrimaryDiscographyRequestSortFieldsInnerFieldEnum];

/**
 * @export
 */
export const PrimaryDiscographyRequestSortFieldsInnerOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type PrimaryDiscographyRequestSortFieldsInnerOrderEnum = typeof PrimaryDiscographyRequestSortFieldsInnerOrderEnum[keyof typeof PrimaryDiscographyRequestSortFieldsInnerOrderEnum];


/**
 * Check if a given object implements the PrimaryDiscographyRequestSortFieldsInner interface.
 */
export function instanceOfPrimaryDiscographyRequestSortFieldsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "order" in value;

    return isInstance;
}

export function PrimaryDiscographyRequestSortFieldsInnerFromJSON(json: any): PrimaryDiscographyRequestSortFieldsInner {
    return PrimaryDiscographyRequestSortFieldsInnerFromJSONTyped(json, false);
}

export function PrimaryDiscographyRequestSortFieldsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrimaryDiscographyRequestSortFieldsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'field': json['field'],
        'order': json['order'],
    };
}

export function PrimaryDiscographyRequestSortFieldsInnerToJSON(value?: PrimaryDiscographyRequestSortFieldsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'field': value.field,
        'order': value.order,
    };
}

